import React from "react";
import { useNavigate } from "react-router-dom";
import themeLarge from "../../ThemeLarge";

const ViewDetailsButton = ({ slug }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/projects/${slug}`);
  };

  return (
    <button
      onClick={handleClick}
      style={{
        width: "100%",
        marginTop: "20px",
        fontFamily: "Kumbh Sans",
        fontSize: themeLarge.fontSize.h3,
        textAlign: "center",
        borderColor: themeLarge.colors.primary,
        background: themeLarge.colors.primary,
        borderWidth: "1px",
        borderStyle: "dashed",
        color: themeLarge.colors.bg,
        paddingTop: "10px",
        paddingBottom: "10px",
        borderRadius: "15px",
        boxShadow: themeLarge.shadows.standard,
      }}
    >
      View Details
    </button>
  );
};

export default ViewDetailsButton;
